module.exports = __webpack_public_path__ + "static/media/small-close.bf549e89.png";